import { PILOT_READ_ONLY_MESSAGE } from "@/lib/pilot-access";
import { usePilotAccess } from "./pilot-access-context";

export function PilotBanner() {
  const { warning, readOnly, until, timezone, refresh, refreshError } = usePilotAccess();
  if (!readOnly && !warning) return null;
  const date = until ? new Intl.DateTimeFormat("pt-BR", { timeZone: timezone }).format(new Date(until)) : null;
  return <div role={readOnly ? "alert" : "status"} className="mx-4 my-2 rounded-xl border border-accent-warm bg-accent-warm-soft px-4 py-3 text-sm text-app-fg-strong">
    <p>{readOnly ? PILOT_READ_ONLY_MESSAGE : `Seu período piloto termina em ${date}. Fale com a CliniSharp para continuar.`}</p>
    {refreshError && <p role="alert" className="mt-2">{refreshError}</p>}
    {readOnly && <button type="button" onClick={refresh} className="mt-2 min-h-11 rounded-md px-2 font-semibold underline focus-visible:ring-2 focus-visible:ring-brand">Atualizar acesso</button>}
  </div>;
}
